import React, { useState } from "react";
import LaunchpadComponent from "../Launchpad/LaunchpadComponent";
import Pagination from "../Pagination";

function AllIDOSequence({ Activedata, Upcomingdata, Endedata }) {
  const [showPerPage, setshowPerPage] = useState(6);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });
  let TotalContent = 1;
  const onPaginationsChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  let Arr = [];
  Activedata.map((data, key) => {
    Arr.push(data);
  });
  Upcomingdata.map((data, key) => {
    Arr.push(data);
  });
  Endedata.map((data, key) => {
    Arr.push(data);
  });
  TotalContent = Arr.length;

  return (
    <>
      <div className="container cardlist">
        {Arr.slice(pagination.start, pagination.end).map((data, key) => (
          <LaunchpadComponent key={key} data={data} />
        ))}
      </div>
      <Pagination
        showPerPage={showPerPage}
        onPaginationsChange={onPaginationsChange}
        totalContent={TotalContent}
      />
    </>
  );
}

export default AllIDOSequence;
